<template>
    <div>
        <div class="bg-tc-green-1 h-11 mx-5 rounded-full flex items-center justify-center" @click="clickGetFriend()">
            <img class="h-6 pr-2.5" src="../../../assets/fgf/ic-line-btn.png" />
            <div class="text-20 text-center text-white">{{ lbl.getfriend.invite_friend }}</div>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import LineFunction from '@/helper/facade/LineFunction.js';
//component
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin';
//service
import BzbsGetFriend from '@/core/GetFriend/service/BzbsGetFriend.js';

export default {
    name: 'LineGetFriend',
    mixins: [ModalMixin,LocaleMixin],
    components: {
    },
    methods: {
        clickGetFriend: function() {
            this.loadingModal.show();
            return new Promise((resolve) => {
                BzbsGetFriend.apiGetFriendLink().subscribe({
                next: (link) => {
                    console.log(link)
                    this.openShareLink(link);
                    resolve(true)
                },
                error: (err) => {
                    this.errorApi(err);
                    this.loadingModal.hide();
                    resolve(false)
                },
            });
        })
        },
       openShareLink: function(link) {
            if (Util.isEmptyStr(link)) {
                console.log('link is null');
                return;
            }

            var line = new LineFunction();
            var liffId = line.getLiffId();
            line.init(liffId).then(() => {
                console.log(link)
                line.shareTextToFriends(link).then((data) => {
                    // success
                    console.log(data);
                }).catch((err) => {
                    console.log(err);
                });
            });
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
